import React, { useState, useEffect } from "react";
import swal from "sweetalert";
import { toast } from "react-toastify";
import Select from "react-select";
import makeAnimated from "react-select/animated";

import commoncss from "../../myfin_v2/css/common.module.css";
import buttoncss from "../../myfin_v2/css/button.module.css";
import Modal from "../../myfin_v2/elements/Modal";
import { Button } from "../../myfin_v2/elements/Button";
import Dropdown from "../../myfin_v2/elements/Dropdown";
import { ReactComponent as CloseIcon } from "../../myfin_v2/assets/icons/close.svg";
import InputGroup from "../../myfin_v2/elements/InputGroup";
import {
  getPopulateFSDetailsApiHandler,
  mapReceivableDisclosureApiHandler,
} from "../../WorkSpace/Components/ApiServices/apiHandler";

const MapRegModal = ({ setMapRegModal, selRecRegCY, selRecRegPY }) => {
  const [category, setCategory] = useState([{}]);
  const [notes, setNotes] = useState([{}]);
  const [selNote, setSelNote] = useState(null);

  const project_id = localStorage.getItem("project_id");

  const getPopulateFS = (cat) => {
    const getParams = {
      category: cat,
      projectID: project_id,
    };
    getPopulateFSDetailsApiHandler(getParams)
      .then((response) => {
        if (response?.data?.success === true) {
          const catData = response?.data?.data;
          catData.forEach((obj) => {
            setNotes((prev) => [
              ...prev,
              { label: obj.particular, value: obj },
            ]);
          });
        }
      })
      .catch((error) => {
        setNotes([{}]);
      });
  };

  useEffect(() => {
    setNotes([{}]);
    if (category) {
      getPopulateFS(category);
    }
  }, [category]);

  const handleConfirmMapping = () => {
    console.log("selRecRegCY", selRecRegCY);

    const payload = {
      category: category,
      parentID: selNote._id,
      projectID: project_id,
      cy: selRecRegCY[0]?.data?._id,
      py: selRecRegPY[0]?.data?._id,
    };
    console.log("payload", payload);
    mapReceivableDisclosureApiHandler(payload)
      .then((response) => {
        console.log("response?.data", response?.data);

        if (response?.data?.success === true) {
          setMapRegModal(false);
          swal("Data mapped successfully", "", "success");
        } else {
          swal("Error", response?.data?.error || "Unable to map data", "error");
        }
      })
      .catch((error) => {
        swal(
          "Error",
          error?.response?.data?.error || "Unable to map data",
          "error"
        );
      });
  };
  return (
    <Modal
      width={"35%"}
      minHeight={"350px"}
      title="Map"
      bodycss={commoncss.unsetPadding}
      headerActions={
        <>
          <CloseIcon
            onClick={() => {
              setMapRegModal(false);
            }}
          />
        </>
      }
      onClose={() => console.log("Modal Closed")}
      footerActions={
        <>
          <Button
            btnColor={buttoncss.secondary}
            onClick={() => {
              setMapRegModal(false);
            }}
            label="Cancel"
          />
          <span>
            &ensp;
            <Button
              btnColor={buttoncss.primary}
              label="Confirm Mapping"
              onClick={() => {
                handleConfirmMapping();
              }}
            />
          </span>
        </>
      }
    >
      <div className={commoncss.pd1530}>
        <Dropdown
          label="Category"
          options={[
            { label: "Balance Sheet", value: "BS notes" },
            { label: "PL", value: "PL notes" },
          ]}
          onSelect={(e) => {
            setCategory(e.value);
          }}
          placeHolder={"Select Category"}
        />
        <Dropdown
          label="Notes"
          options={notes}
          onSelect={(e) => {
            setSelNote(e.value);
          }}
          placeHolder={"Select Notes"}
        />
      </div>
    </Modal>
  );
};

export default MapRegModal;
